export default __webpack_public_path__ + "static/media/monkey.2ce062b5.svg";